import { memo as Memo } from 'react';

//* Components
import CustomCollapse from '@components/global/CustomCollapse';
import Text from '../Text';

//* Styles
import ErrorMsgStyle from './style';

const FieldErrorMsg = Memo(({ msg }) => {
	return (
		<ErrorMsgStyle>
			<CustomCollapse isCollapsed={!!msg}>
				<Text
					tag={'span'}
					className={`errMsg p font-poppins font-regular`}>
					{msg}
				</Text>
			</CustomCollapse>
		</ErrorMsgStyle>
	);
});

export default FieldErrorMsg;
